import axios from "../utils/index";
import {
  normalizeUploadPreviewUrl,
  normalizeUploadReference,
} from "../utils/uploadResponseUtils";

const api = {
  async upload(data: any, callback: (T: any) => void) {
    axios
      .post(`/v1/public/upload/upload-file`, data)
      .then((res) => {
        if (res?.data?.data != null) {
          const raw = res.data.data;
          const objectKey = normalizeUploadReference(raw);
          const previewUrl = normalizeUploadPreviewUrl(raw);
          res.data.data = objectKey;
          res.data.previewUrl = previewUrl || objectKey;
        }
        callback(res.data);
      })
      .catch((err) => {
        callback(err);
      });
  },
  uploadApi({
    params = {} as any,
    callback = (() => {}) as any,
    cancelToken = null as any,
  }) {
    axios
      .post(`/v1/public/upload/upload-file`, params, { cancelToken })
      .then((res) => {
        if (res?.data?.data != null) {
          const raw = res.data.data;
          const objectKey = normalizeUploadReference(raw);
          const previewUrl = normalizeUploadPreviewUrl(raw);
          res.data.data = objectKey;
          res.data.previewUrl = previewUrl || objectKey;
        }
        callback(res);
      })
      .catch((err) => {
        callback(err);
      });
  },
};

export default api;
